/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_SORT = "CREATED_AT_ASC" | "CREATED_AT_DESC" | "REACTION_DESC" | "REPLIES_DESC" | "%future added value";
export type AllCommentsTabContainerLocal = {
    readonly refreshStream: boolean | null;
    readonly ratingFilter: number | null;
    readonly commentsOrderBy: COMMENT_SORT;
    readonly commentsFullyLoaded: boolean | null;
    readonly keyboardShortcutsConfig: {
        readonly key: string;
        readonly source: string;
        readonly reverse: boolean;
    } | null;
    readonly oldestFirstNewCommentsToShow: string | null;
    readonly " $refType": "AllCommentsTabContainerLocal";
};
export type AllCommentsTabContainerLocal$data = AllCommentsTabContainerLocal;
export type AllCommentsTabContainerLocal$key = {
    readonly " $data"?: AllCommentsTabContainerLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"AllCommentsTabContainerLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AllCommentsTabContainerLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "refreshStream",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ratingFilter",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "commentsOrderBy",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "commentsFullyLoaded",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "KeyboardShortcutsConfig",
                    "kind": "LinkedField",
                    "name": "keyboardShortcutsConfig",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "key",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "source",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "reverse",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "oldestFirstNewCommentsToShow",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '3ee42119993708096da45d3c5cea0254';
export default node;
